import { baseState, baseMutations } from '@/store/mixins'
import healthItem from '@/api/health-item'

export const state = {
  ...baseState,
  categories: []
}
export const getters = {}
export const mutations = {
  ...baseMutations,
  SET_CATEGORIES (state, data) {
    state.categories = data
  }
}
export const actions = {
  fetch (context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return healthItem.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  create (context, data) {
    return healthItem.store(data)
  },
  update (context, data) {
    return healthItem.update(data)
  },
  delete (context, data) {
    return healthItem.destroy(data)
  },
  
  async getCategory (context, health_category_id) {
    context.commit('SET_CATEGORIES', [])
    let response = await healthItem.category(health_category_id)
    context.commit('SET_CATEGORIES', response)
  },
}
